export const IconLib = {
   actions: {
      close: 'ph:x',
      cancel: 'ph:x',
      loading: 'uil:sync',
      search: 'uil:search',
      plus: 'ph:plus',
      list: 'ph:list-bullets',
      minus: 'ph:minus',
      eye: {
         open: 'material-symbols:visibility-outline',
         close: 'material-symbols:visibility-off-outline-rounded',
      },
      camera: 'uil:camera',
      edit: 'ph:pencil-simple-line',
      copy: 'ph:copy',
      check: 'ph:check',
      expand: 'mdi:arrow-expand',
      collapse: 'mdi:arrow-collapse',
      save: 'ph:floppy-disk',
      delete: 'ph:trash',
      arrow: {
         left: 'ph:arrow-left',
         up: 'ph:caret-up',
         down: 'ph:caret-down',
         right: 'ph:arrow-right',
         rightBold: 'ph:arrow-right-bold',
      },
      zoom: {
         in: 'ph:magnifying-glass-plus',
         out: 'ph:magnifying-glass-minus',
      },
      externalLink: 'uil:external-link-alt',
      options: 'ph:dots-three-bold',
   },
   sidebar: {
      home: 'uil:home-alt',
      map: 'uil:map',
      chat: 'uil:comment-message',
      profile: 'uil:user-circle',
      settings: 'uil:cog',
      signOut: 'ph:sign-out-bold',
      api: 'carbon:api-1',
      cookie: 'ph:cookie-bold',
      admin: 'ph:users',
      documents: 'ph:folder',
      projects: 'ph:folders',
      learningLibrary: 'ph:book-open',
   },
   project: {
      document: 'ph:file-text',
      members: 'ph:users',
   },
   menuToggle: {
      // sm screen menu toggle button
      menu: 'uil:align-justify',
      closeMenu: 'uil:times',
   },
   loading: {
      spinner: 'svg-spinners:180-ring-with-bg',
      dots: 'svg-spinners:3-dots-fade',
   },
   error: {
      triangle: 'uil:exclamation-triangle',
      circle: 'uil:exclamation-circle',
   },
   info: 'ph:info',
   map: {
      marker: 'heroicons:map-pin-16-solid',
   },
   weather: {
      // weather widget
      humidity: 'mdi:water-outline',
      windSpeed: 'mdi:weather-windy',
      clouds: 'mdi:weather-cloudy',
      uvIndex: 'ph:sun',
      pressure: 'ph:arrows-in-line-vertical',
      weatherCondition: {
         Clear: 'mdi:weather-sunny',
         Clouds: 'mdi:weather-cloudy',
         Rain: 'mdi:weather-rainy',
         Drizzle: 'mdi:weather-partly-rainy',
         Thunderstorm: 'mdi:weather-lightning-rainy',
         Snow: 'mdi:weather-snowy',
         Mist: 'mdi:weather-fog',
         Fog: 'mdi:weather-fog',
         Haze: 'mdi:weather-hazy',
         Dust: 'mdi:weather-dust',
         Smoke: 'mdi:weather-dust',
         Squall: 'mdi:weather-windy',
         Tornado: 'mdi:weather-tornado',
         DEFAULT: 'mdi:weather-cloudy',
      },
   },
   watchLocation: {
      home: 'ph:house',
      office: 'ph:briefcase',
      pin: 'ph:map-pin',
   },
   dataSource: {
      gitBranch: 'ph:git-branch',
      api: 'carbon:api-1',
      calendar: 'ph:calendar-blank',
   },
   navItemsTop: {
      home: 'uil:home-alt',
      map: 'uil:map',
      comment: 'uil:comment',
      profile: 'uil:user-circle',
      settings: 'uil:cog',
   },
   navItemsTopBottom: {
      api: 'carbon:api-1',
      signout: 'uil:signout',
   },
   chat: {
      send: 'ph:paper-plane-right',
      mic: 'ph:microphone',
      pause: 'ph:pause',
      chats: 'ph:chats',
      thumbsUp: {
         outline: 'ph:thumbs-up',
         fill: 'ph:thumbs-up-fill',
      },
      thumbsDown: {
         outline: 'ph:thumbs-down',
         fill: 'ph:thumbs-down-fill',
      },
      check: 'ph:check-circle',
      x: 'ph:x-circle',
   },
   pdf: 'mdi:file-pdf',
   legal: {
      privacyPolicy: 'ph:lock',
      termsAndConditions: 'ph:file',
      cookie: 'ph:cookie',
   },
};
